const px=(n:number)=>{
    return n/1920*(window as any).pageWidth
}
export default px
